export default {
  "nav.spreadsheet": "Tabelle",
  "nav.products": "Produkte",
  "nav.sellers": "Verkäufer",
  "nav.reviews": "Bewertungen",
  "nav.shipping": "Versand",
  "nav.guides": "Anleitungen",
  "nav.safety": "Sicherheit",
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",
  "nav.categories": "Kategorien",
  "nav.cta": "Hauptseite besuchen",

  "hero.badge": "Unabhängige Kaufressource",
  "hero.title": "AllChinaBuy Spreadsheet — Produkte, Verkäufer & Kauflleitfäden",
  "hero.subtitle":
    "Entdecke organisierte AllChinaBuy-Tabellen, Produktfunde, Verkäufer-Ressourcen, QC-Anleitungen, Versandinfos, Bewertungen und praktische Kauf-Tutorials — alles an einem Ort.",
  "hero.searchPlaceholder": "Produkte, Verkäufer, Kategorien oder AllChinaBuy-Anleitungen suchen…",
  "hero.ctaPrimary": "allchinabuy spreadsheet",
  "hero.ctaSecondary": "jetzt kaufen",
  "hero.trust": "Unabhängige Kaufressource • Aktualisierter Inhalt • Praktische Anleitungen • Sicherheitsorientierte Recherche",

  "categories.label": "Nach Kategorie durchsuchen",
  "categories.title": "Finde schneller, was du brauchst",
  "categories.subtitle":
    "Springe direkt zu dem Bereich des Hauptshops, den du brauchst — jede Kategorie unten öffnet die passende Produktliste.",

  "featured.title": "Deine komplette AllChinaBuy Spreadsheet-Ressource",
  "featured.subtitle":
    "Recherchiere zuerst und gehe dann zur Hauptseite, wenn du bereit bist. Diese Anleitungen decken die Themen ab, nach denen Käufer am häufigsten fragen.",
  "featured.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "featured.spreadsheet.desc":
    "Durchsuche organisierte Produktressourcen und beliebte Kategorien.",
  "featured.review.title": "AllChinaBuy Bewertung",
  "featured.review.desc":
    "Verstehe Plattform, Kosten, Funktionen, Stärken und Grenzen.",
  "featured.shipping.title": "AllChinaBuy Versandkosten",
  "featured.shipping.desc":
    "Erfahre, wie Gewicht, Abmessungen, Zielort und Versandlinien die Kosten beeinflussen.",
  "featured.qc.title": "AllChinaBuy QC",
  "featured.qc.desc":
    "Verstehe QC-Fotos, Inspektion und Kontrollen vor dem Versand.",
  "featured.warehouse.title": "AllChinaBuy Lager",
  "featured.warehouse.desc":
    "Erfahre, wie Lagerung, Inspektion und Konsolidierung funktionieren.",
  "featured.safety.title": "AllChinaBuy Sicherheit",
  "featured.safety.desc":
    "Lerne, gefälschte Websites, Phishing und riskante Verkäufer zu erkennen.",

  "searches.title": "Beliebte Suchanfragen",
  "searches.subtitle": "Die Fragen und Themen, die Leser am häufigsten suchen.",
  "searches.item1": "AllChinaBuy Bewertung",
  "searches.item2": "AllChinaBuy Versandkosten",
  "searches.item3": "AllChinaBuy Gutschein",
  "searches.item4": "AllChinaBuy Rabattcode",
  "searches.item5": "AllChinaBuy Lager",
  "searches.item6": "AllChinaBuy seriös",

  "why.title": "Warum diese Ressource nutzen",
  "why.subtitle": "Entwickelt, um den Kauf aus China klarer, sicherer und leichter vergleichbar zu machen.",
  "why.point1.title": "Organisierte Kategorien",
  "why.point1.desc": "Jeder Produkttyp ist gruppiert, damit du schnell eine realistische Preisspanne findest.",
  "why.point2.title": "Originale Anleitungen",
  "why.point2.desc": "Erklärungen in klarer Sprache für echte Käufer, kein recycelter Fülltext.",
  "why.point3.title": "Sicherheit zuerst",
  "why.point3.desc": "Praktische Tipps zum Erkennen von Fake-Seiten, Phishing und riskanten Verkäufern.",
  "why.point4.title": "Direkt zum Shop",
  "why.point4.desc": "Klare ausgehende Links führen dich zum genau richtigen Bereich, wenn du bereit bist.",

  "articles.title": "Neueste Artikel",
  "articles.subtitle": "Originale, ausführliche Anleitungen zur AllChinaBuy-Tabelle.",
  "articles.readMore": "Anleitung lesen",
  "articles.cardTitle": "AllChinaBuy Spreadsheet: Die komplette 2026-Anleitung",
  "articles.cardDesc":
    "Produkte, Verkäufer, QC-Fotos und Versand — so organisierst du jede Bestellung in einer klaren, sortierbaren Tabelle.",

  "faq.title": "Häufig gestellte Fragen",
  "faq.subtitle": "Schnelle Antworten auf die häufigsten Käuferfragen.",
  "faq.q1": "Was ist eine AllChinaBuy-Tabelle?",
  "faq.a1":
    "Es ist ein selbst organisierter Nachverfolgungsbogen für Bestellungen über eine chinesische Kaufplattform — mit Produkten, Verkäufern, Preisen, QC-Status und Versanddetails in einer sortierbaren Ansicht.",
  "faq.q2": "Ist dies die offizielle AllChinaBuy-Website?",
  "faq.a2":
    "Nein. Dies ist eine unabhängige Informationsressource ohne offizielle Zugehörigkeit. Für offizielle Angaben prüfe immer direkt die aktuelle Plattform.",
  "faq.q3": "Brauche ich eine Tabelle für kleine Bestellungen?",
  "faq.a3":
    "Nicht unbedingt, aber ein einfacher Bogen hilft trotzdem, die Gesamtkosten verschiedener Verkäufer zu vergleichen und QC- sowie Gewichtsnotizen an einem Ort zu halten.",
  "faq.q4": "Welche Kategorien kann ich hier durchsuchen?",
  "faq.a4":
    "Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckung, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und mehr — jeweils verlinkt auf den passenden Bereich des Hauptshops.",

  "cta.title": "Bereit, mehr zu entdecken?",
  "cta.text":
    "Nutze unsere Anleitungen, um zuerst zu recherchieren, und gehe dann zur Hauptseite, wenn du bereit bist.",
  "cta.button": "Zur Hauptseite",

  "footer.tagline": "Die komplette Produkt-, Verkäufer-, QC- und Kaufressource",
  "footer.disclaimer":
    "Dies ist eine unabhängige Informationswebsite und nicht mit AllChinaBuy verbunden oder von ihr unterstützt. Preise, Versand und Richtlinien ändern sich — prüfe immer die aktuelle offizielle Plattform.",
  "footer.resourcesTitle": "Ressourcen",
  "footer.legalTitle": "Rechtliches",
  "footer.languagesTitle": "Sprachen",
  "footer.about": "Über uns",
  "footer.editorial": "Redaktionelle Richtlinie",
  "footer.safety": "Sicherheitszentrum",
  "footer.disclaimerLink": "Haftungsausschluss",
  "footer.privacy": "Datenschutz",
  "footer.terms": "AGB",
  "footer.contact": "Kontakt",
  "footer.sitemap": "Sitemap",
  "footer.mainSite": "Hauptseite",
  "footer.rights": "Alle Rechte vorbehalten.",

  "category.shoes": "Schuhe",
  "category.hoodies": "Hoodies / Pullover",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jacken",
  "category.pants": "Hosen / Shorts",
  "category.headwear": "Kopfbedeckung",
  "category.sets": "Sets",
  "category.underwear": "Unterwäsche",
  "category.jersey": "Trikots",
  "category.accessories": "Accessoires",
  "category.bags": "Taschen",
  "category.belts": "Gürtel",
  "category.perfumes": "Parfums",
  "category.other": "Sonstiges",

  "article.notFound": "Artikel nicht gefunden",
  "article.summary": "Zusammenfassung",
  "article.backHint": "Kehre zur Startseite zurück, um alle Kategorien und Anleitungen zu durchsuchen.",

  "category.guide": "Anleitung",
  "category.review": "Bewertung",
  "category.safety": "Sicherheit",
  "category.shipping": "Versand",
  "category.warehouse": "Lager",
  "category.qc": "Qualitätskontrolle",
  "category.coupons": "Gutscheine",
  "category.comparison": "Vergleich",
  "category.beginners": "Anfänger",
};